import Modal from "react-modal";

import { useMobileVersion } from "./contexts/Mobile";
import { useTheme } from "./contexts/Theme";

import { useState } from "react";

import { useThemeCookie } from "./hooks/themeCookieExtractor";
import { useEffectPreventZoom } from "./hooks/preventZoomMonitor";
import useOrientationTracker from "./hooks/orientationMonitor";
import useAuthChecker from "./hooks/authChecker";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import Login from "./components/Login";
import MainPage from "./components/Main";
import Photos from "./components/Photos";

Modal.setAppElement("#root");

function App() {
  const { isMobile } = useMobileVersion();
  const { isDark, setDark } = useTheme();

  const [isVertical, setVertical] = useState(false);
  const [username, setUsername] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isQuizCompleted, setIsQuizCompleted] = useState(false);

  useOrientationTracker(setVertical);
  useThemeCookie(setDark);
  useEffectPreventZoom();
  useAuthChecker(
    setUsername,
    setIsAuthenticated,
    setIsLoaded,
    setIsQuizCompleted
  );

  return (
    <>
      {isLoaded ? (
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <Navigate to={`/${isAuthenticated ? "main" : "login"}`} />
              }
            />
            <Route
              path="/login"
              element={
                isAuthenticated ? (
                  <Navigate to="/main" />
                ) : (
                  <Login
                    isMobile={isMobile}
                    isVertical={isVertical}
                    isDark={isDark}
                    setDark={setDark}
                    username={username}
                    setUsername={setUsername}
                    setAuth={setIsAuthenticated}
                    setIsQuizCompleted={setIsQuizCompleted}
                  />
                )
              }
            />
            <Route
              path="/main"
              element={
                isAuthenticated ? (
                  <MainPage
                    isMobile={isMobile}
                    isVertical={isVertical}
                    isDark={isDark}
                    setDark={setDark}
                    username={username}
                    setAuth={setIsAuthenticated}
                    isQuizCompleted={isQuizCompleted}
                    setIsQuizCompleted={setIsQuizCompleted}
                  />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/photos"
              element={
                isAuthenticated ? (
                  <Photos
                    isMobile={isMobile}
                    isVertical={isVertical}
                    isDark={isDark}
                    setDark={setDark}
                  />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
          </Routes>
        </Router>
      ) : (
        <div
          className={`flex h-screen w-screen ${
            isDark
              ? "bg-gradient-to-b from-gray-800 to-slate-900"
              : "bg-gradient-to-b from-white to-red-100"
          }`}
        ></div>
      )}
    </>
  );
}

export default App;
